import styled from "styled-components";
import React, { useEffect, useState } from 'react';
import { P } from "@src/components/atoms";
import { ThemeType } from "@src/types/theme";
import { t_library } from "@src/types/tables";
import { useTranslation } from "next-i18next";

export type DetailTagsProps = {
    data: t_library;
};

export default function DetailTags(props: DetailTagsProps)
{
    const { t } = useTranslation("common");

    const [ nation, setNation ] = useState<string[]>([]);
    const [ genre, setGenre ] = useState<string[]>([]);
    const [ mood, setMood ] = useState<string[]>([]);
    const [ theme, setTheme ] = useState<string[]>([]);
    const [ tempo, setTempo ] = useState<string[]>([]);

    useEffect(() => {
        if (props.data)
        {
            setNation(props.data.nation ? props.data.nation.split(',') : []);
            setGenre(props.data.genre ? props.data.genre.split(',') : []);
            setMood(props.data.mood ? props.data.mood.split(',') : []);
            setTheme(props.data.theme ? props.data.theme.split(',') : []);
            setTempo(props.data.tempo ? props.data.tempo.split(',') : []);
        }
    }, [props.data]);

    return(
        <Wrapper>
            { mood.length > 0 &&
                <TagCategory>
                    <TagName>{ "분위기" }</TagName>
                    <TagWrapper>
                        { mood.map((tag, index) => 
                            <TagBox key={"tag" + index}>
                                <Tag>{"#" + tag}</Tag>
                            </TagBox>
                        )}
                    </TagWrapper>
                </TagCategory>
            }
            { genre.length > 0 &&
                <TagCategory>
                    <TagName>{ "장르" }</TagName>
                    <TagWrapper>
                        { genre.map((tag, index) => 
                            <TagBox key={"tag" + index}>
                                <Tag>{"#" + tag}</Tag>
                            </TagBox>
                        )}
                    </TagWrapper>
                </TagCategory>
            }
            { theme.length > 0 &&
                <TagCategory>
                    <TagName>{ `${"장면"}/${"테마"}` }</TagName>
                    <TagWrapper>
                        { theme.map((tag, index) => 
                            <TagBox key={"tag" + index}>
                                <Tag>{"#" + tag}</Tag>
                            </TagBox>
                        )}
                    </TagWrapper>
                </TagCategory>
            }
            { tempo.length > 0 &&
                <TagCategory>
                    <TagName>{ "템포" }</TagName>
                    <TagWrapper>
                        { tempo.map((tag, index) => 
                            <TagBox key={"tag" + index}>
                                <Tag>{"#" + tag}</Tag>
                            </TagBox>
                        )}
                    </TagWrapper>
                </TagCategory>
            }
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width: 100%;
    height: fit-content;
    padding-left: 40px;
    flex: 1;

    ${({ theme }: { theme: ThemeType }) => theme.largeTablet`
        padding-left: 0;
	`};
`;

const TagCategory = styled.div`
    margin-bottom: 32px;
`;

const TagName = styled(P)`
    color: #999;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
    line-height: normal; 

    ${({ theme }: { theme: ThemeType }) => theme.mobile`
        font-size: 0.25rem;
        line-height: 0.35rem;
	`};
`;

const TagWrapper = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
`;

const TagBox = styled.div`
    height: 34px;
    min-width: 80px;
    padding: 0 20px;
    margin: 15px 15px 0 0;
    border: 1px solid #999;
    border-radius: 100px;
`;

const Tag = styled(P)`
    color: #FFF;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 700;
    line-height: 32px; 
    white-space: nowrap;

    ${({ theme }: { theme: ThemeType }) => theme.mobile!`
        font-size: 0.15rem;
	`};
`;